import { Fade, Skeleton, useTheme } from "@mui/material";

export function PendingIndicator({ isPending }: { isPending: boolean }) {
  const theme = useTheme();

  if (!isPending) return null;

  return (
    <Fade in={isPending} timeout={750}>
      <Skeleton
        variant="rounded"
        animation="wave"
        height={theme.spacing(2)}
        sx={{
          alignSelf: "center",
          borderRadius: theme.shape.borderRadius,
          flex: {
            xs: 0.7,
            sm: 0.4,
            md: 0.5,
          },
        }}
      />
    </Fade>
  );
}
